module.exports = __webpack_public_path__ + "assets/c3150abd5fd077db2e4809804494a141.jpg";